<div class="property-value" *ngIf="getProperty()" ngModelGroup="propertyLine">
  <div *ngIf="constraints.length && parsedConstraints">
    <div class="input-group" *ngIf="isPropertyNumeric()">
      <ng-select class="select-sm form-control" [items]="parsedConstraints" name="bottleneck" [(ngModel)]="propertyLine.NumericValue"
        bindLabel="Value" [virtualScroll]="true"
        bindValue="Id">
      </ng-select>
      <span *ngIf="getProperty().UnitId" class="input-group-text">{{ (units | filterBy: 'Id' : getProperty().UnitId)[0]?.Code }}</span>
    </div>
    <!--<div class="col-sm-12" ng-if="property.TypeClv === helper.propertyTypes.Choice">-->
    <!--<nt-single-select css="col-sm-12 no-padding" ng-disabled="readOnly" field-schema="helper.idlSchema.ValueClv" ng-model="model.ValueClv" allow-empty="true" nt-change="onDefaultValueChanged($value, model)" nt-option-value="Id" nt-option-name="Value" nt-source="parsedConstraints" place-holder="getChoiceValue(defaultValue.ValueClv)">-->
    <!--</nt-single-select>-->
    <!--</div>-->
    <!--<div class="col-sm-12" ng-if="property.TypeClv === helper.propertyTypes.Text">-->
    <!--<nt-single-select css="col-sm-12 no-padding" ng-disabled="readOnly" field-schema="helper.idlSchema.Value" ng-model="model.Value" allow-empty="true" nt-change="onDefaultValueChanged($value, model)" nt-option-value="Id" nt-option-name="Value" nt-source="parsedConstraints" place-holder="defaultValue.Value">-->
    <!--</nt-single-select>-->
    <!--</div>-->
  </div>
  <div class="row" *ngIf="!constraints.length">
    <div class="col" *ngIf="isPropertyNumeric()">
      <div class="input-group">
        <input type="number" class="form-control" name="number-{{propertyLine.Id}}" [(ngModel)]="propertyLine.NumericValue" [disabled]="readOnly" (input)="onDefaultValueChanged($event.target.value)" [placeholder]="defaultLine.NumericValue  || ''">
        <span *ngIf="getProperty().UnitId" class="input-group-text">{{getUnit()}}</span>
      </div>
    </div>
    <div class="col" *ngIf="isPropertyChoice()">
      <mes-web-classificator-value-select name="choice-{{propertyLine.Id}}"
        [items]="classificatorValueService.getAll$ | async | filterBy: ['ClassificatorId']: getProperty().ChoiceTypeClassificatorId"
        [entityId]="propertyLine.ValueClv"
        (entityIdChange)="propertyLine.ValueClv = $event; onDefaultValueChanged($event)"
        [classificatorId]="getProperty().ChoiceTypeClassificatorId"
        [placeholder]="getChoiceValue(defaultLine.ValueClv)  || ''"></mes-web-classificator-value-select>
    </div>
    <div class="col" *ngIf="isPropertyText()">
      <textarea name="text-{{propertyLine.Id}}" class="form-control" rows="2" [(ngModel)]="propertyLine.Value" (change)="onDefaultValueChanged($event.target.value)" [placeholder]="defaultLine.Value || ''"></textarea>
    </div>
    <div class="col" *ngIf="isPropertyHtml()">
      <textarea name="html-{{propertyLine.Id}}" class="form-control" rows="2" [(ngModel)]="propertyLine.Value" (change)="onDefaultValueChanged($event.target.value)" [placeholder]="defaultLine.Value  || ''"></textarea>
    </div>
    <div class="col" *ngIf="isPropertyDateTime()">
      <input class="form-control" id="datetime-{{propertyLine.Id}}" name="datetime-{{propertyLine.Id}}" [(ngModel)]="propertyLine.DateTimeValue" ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" (ngModelChange)="onDefaultValueChanged($event)">
    </div>
  </div>
</div>
